import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RESET_SAVE_TEMPORARY_DATA } from "../../redux/constants";

function BackButtonWindow({ backButtonName, title, path, state }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    if (path !== "") {
      navigate(path, {state});
    }
  };

  return (
    <div className="bg-[#2F80ED] opacity-80 py-3 flex justify-center items-center relative">
      <div className="flex items-center space-x-4">
        <p className="text-[#fff] text-sm font-semibold leading-6 capitalize">
          {title}
        </p>
        <button
          className="text-white border-2 border-white rounded-full text-sm font-semibold leading-6 px-4 py-1 capitalize"
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
        >
          {`Go Back To ${backButtonName}`}
        </button>
      </div>
      <div className="absolute right-0 mr-10">
        <p
          className="text-sm text-[#fff] leading-5 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
          }}
        >
          Dismiss
        </p>
      </div>
    </div>
  );
}

export default BackButtonWindow;
